import { render, staticRenderFns } from "./aboutUsV2.vue?vue&type=template&id=7d8201c6&scoped=true&"
import script from "./aboutUsV2.vue?vue&type=script&lang=js&"
export * from "./aboutUsV2.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsV2.vue?vue&type=style&index=0&id=7d8201c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8201c6",
  null
  
)

export default component.exports